<template>
  <div>
    <md-toolbar class="md-success" md-elevation="0" style="min-height: 100px">
      <form
        novalidate
        class="md-layout md-alignment-center-center"
        style="width: 100%"
        @submit.prevent="filterData"
      >
        <div class="md-layout-item md-size-40">
          <slot name="title">
            <h3 class="md-title">Concepto</h3>
          </slot>
        </div>
        <div class="md-layout-item">
          <div class="outlined-field">
            <md-field>
              <label> Buscar por nombre o código</label>
              <md-input v-model="searchQuery"></md-input>
            </md-field>
          </div>
        </div>
        <md-button
          type="submit"
          style="margin-left: 8px; height: 48px"
          class="md-secondary"
        >
          <md-icon>search</md-icon>
        </md-button>
      </form>
      <div class="md-layout md-alignment-center-right">
        <h4 v-if="concepts.length && !loading">
          Mostrando {{ concepts.length }} conceptos
        </h4>
      </div>
    </md-toolbar>

    <md-table v-if="concepts.length && !loading" id="concepts-table">
      <md-table-row>
        <md-table-head style="width: 100px"> </md-table-head>
        <md-table-head v-for="(header, index) in headers" :key="index">
          {{ header.text }}
        </md-table-head>
      </md-table-row>

      <template v-for="(concept, index) in concepts" v-if="concepts.length">
        <md-table-row :key="index">
          <md-table-cell style="width: 100px">
            <md-button
              class="md-info md-round md-just-icon"
              @click="showSupplies(concept, index)"
            >
              <md-icon>{{
                !concept.showSupplies ? "expand_more" : "expand_less"
              }}</md-icon>
            </md-button>
          </md-table-cell>
          <md-table-cell
            v-for="(header, indexHeader) in headers"
            :key="indexHeader"
            :md-label="header.text"
          >
            <span v-if="header.value === 'actions'">
              <md-button
                v-if="canChangeRoadconceptjb"
                class="md-info md-simple md-just-icon"
                @click="editConcept(concept)"
              >
                <md-icon>edit</md-icon>
              </md-button>
              <md-button
                v-if="canDeleteRoadconceptjb"
                class="md-info md-simple md-just-icon"
                @click="deleteConcept(concept, index)"
              >
                <md-icon>close</md-icon>
              </md-button>
            </span>
            <span v-else-if="header.filter === 'money'">
              {{ concept[header.value] | money }}
            </span>
            <span v-else-if="header.value === 'index'">
              <strong>
                {{ index + 1 }}
              </strong>
            </span>
            <span v-else>
              {{ concept[header.value] }}
            </span>
          </md-table-cell>
        </md-table-row>

        <md-table-row v-show="concept.showSupplies && !loadingSupplies">
          <md-table-cell
            :colspan="headers.length + 1"
            v-if="concept.supplies.length && !loadingSupplies"
            class="supply-row"
          >
            <md-table class="concepts-supply-table">
              <h4 style="margin: 12px 18px 0">Insumos</h4>
              <md-table-row>
                <md-table-head
                  v-for="(header, index) in headersSupplies"
                  :key="index"
                >
                  {{ header.text }}
                </md-table-head>
              </md-table-row>

              <md-table-row v-for="supply in concept.supplies" :key="supply.id">
                <md-table-cell
                  v-for="(header, index) in headersSupplies"
                  :key="index"
                >
                  <span v-if="header.value === 'actions'">
                    <md-button class="md-info md-round md-just-icon">
                      <md-icon></md-icon>
                    </md-button>
                  </span>
                  <span v-else-if="header.filter === 'money'">
                    {{ supply[header.value] | money }}
                  </span>
                  <span v-else>
                    {{ supply[header.value] }}
                  </span>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-table-cell>
          <md-table-cell
            :colspan="headers.length + 1"
            v-else-if="!concept.supplies.length && !loadingSupplies"
          >
            <loading-content
              class="md-accent"
              empty-icon="widgets"
              empty-label="No hay insumos"
              empty-description="El concepto no tiene insumos"
            />
          </md-table-cell>
        </md-table-row>
      </template>
    </md-table>

    <loading-content v-else-if="loading" :loading="loading" />
    <loading-content
      v-else
      empty-icon="category"
      empty-label="No hay resultados"
    />

    <road-concept-modal
      v-if="showConceptModal"
      :concept="currentConcept"
      :catalog-id="catalogId"
      :details="details"
      @saved="conceptSaved"
      @updated="conceptUpdated"
      @close="showConceptModal = false"
    />
  </div>
</template>

<script>
import { Modal, TitleToolbar } from "@/components";
import RoadConceptModal from "./RoadConceptForm";
import catalogService from "@/services/catalog";

import mapPermissions from "@/plugins/accountPermissions/mapPermissions";

export default {
  name: "ConceptsList",

  props: {
    concepts: Array,
    loading: Boolean,
    loadingSupplies: Boolean,
    details: {
      type: Array,
      required: true,
    },
    detail: {
      type: Object,
    },
    catalogId: {
      type: Number,
    },
    selectedConcept: {
      type: Object,
      default: null,
    },
  },

  components: {
    RoadConceptModal,
    TitleToolbar,
    Modal,
  },

  methods: {
    filterData() {
      this.$emit("filterData", this.searchQuery);
    },
    showSupplies(concept, index) {
      this.$emit("showSupplies", concept, index);
      this.currentConcept = concept;
    },
    addConcept() {
      const detailId = this.detail.id;
      const { catalogId } = this;
      this.currentConcept = { detailId, catalogId };
      this.showConceptModal = true;
    },
    editConcept(concept) {
      this.currentConcept = concept;
      this.showConceptModal = true;
    },
    deleteConcept(concept, index) {
      this.$confirmMessage(
        {
          title: `Esta seguro que desea borrar el concepto:`,
          text: concept.name,
        },
        () => {
          this.$emit("deleteConcept", concept, index);
        }
      );
    },
    conceptSaved(concept) {
      this.showConceptModal = false;
      this.$emit("saved", concept);
    },
    conceptUpdated(concept) {
      this.showConceptModal = false;
      this.$emit("updated", concept);
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;

        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }

        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
  },

  created() {
    catalogService.fetch("common/unit_measurement", { useStore: true });
    catalogService.fetch("services/details", { useStore: true });
  },

  computed: {
    ...mapPermissions("Services", "roadconceptjb"),
    emptyMessage() {
      const concepts = this.concepts;

      if (!concepts) {
        return "Seleccione un detalle";
      }
      return "No hay conceptos en este detalle";
    },
  },

  data() {
    return {
      fixHeaders: true,
      currentSort: "name",
      currentSortOrder: "asc",
      headers: [
        { text: "#", value: "index" },
        { text: "Nombre", value: "name" },
        { text: "Código", value: "code" },
        { text: "Familia", value: "family" },
        { text: "Subfamilia", value: "subFamily" },
        { text: "Detalle", value: "detailName" },
        { text: "Unidad de medida", value: "unitMeasurementName" },
        { text: "Costo", value: "unitPriceMXN", filter: "money" },
        { text: "Acciones", value: "actions" },
      ],
      headersSupplies: [
        { text: "Nombre", value: "name" },
        { text: "Código", value: "code" },
        { text: "Unidad de  medida", value: "name" },
        { text: "Cantidad", value: "quantity" },
        // { text: "Precio Unitario", value: "unitPriceMXN" },
        // { text: "Total", value: "unitPriceMXN" },
      ],
      currentConcept: null,
      showConceptModal: false,
      hoveredConcept: null,

      searchQuery: "",
      clickedConcept: this.selectedConcept,
    };
  },
  watch: {
    selectedDetail(value) {
      this.$emit("update:sDetail", value);
    },
    selectedConcept(value) {
      this.clickedConcept = value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

.outlined-field {
  background-color: white;
  outline: none;
  border: none;
  padding: 4px 10px;
  border-radius: 4pt;
  height: fit-content;
  .md-field {
    transform: unset;
  }
}
.supply-row {
  padding: 8px 0px;
  background-color: rgb(223, 223, 223);
}

#concepts-table .md-table-cell {
  max-width: 30%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/RoadConceptsAdvance/ConceptsList.vue